const d3 = require("d3");
const dagreD3 = require("dagre-d3");
const graphlib = require("graphlib");

// Expose these to the global window object
window.d3 = d3;
window.dagreD3 = dagreD3;
window.graphlib = graphlib;
